<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        
        <v-col cols="12" FILTERS>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="countries"
                    v-model="selectedCountry"
                    :label="i18n.country"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    dense
                    clearable
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{i18n[item.slug]}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="programs"
                    v-model="selectedProgram"
                    :label="i18n.program"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    clearable
                    dense
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{i18n[item.slug]}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="statuses"
                    v-model="selectedStatus"
                    :label="i18n.status"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    clearable
                    dense
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{i18n[item.slug]}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="usersall"
                    v-model="selectedUser"
                    :label="i18n.employee"
                    autocomplete="disabled"
                    outlined
                    :filter="filterObject"
                    hide-details
                    clearable
                    dense
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{item.name}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{item.name}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fromDate"
                        label="From Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        outlined
                        hide-details
                        dense
                        @change="filterLeads()"
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fromDate"
                      @change="filterLeads()"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="toDate"
                        label="To Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        outlined
                        hide-details
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="toDate"
                      @change="filterLeads()"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fromUpdateDate"
                        label="From Update Date"
                        prepend-icon="update"
                        readonly
                        outlined
                        hide-details
                        dense
                        @change="filterLeads()"
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fromUpdateDate"
                      @change="filterLeads()"
                      @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu4"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="toUpdateDate"
                        label="To Update Date"
                        prepend-icon="update"
                        readonly
                        hide-details
                        outlined
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="toUpdateDate"
                      @change="filterLeads()"
                      @input="menu4 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu5"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="interviewDate"
                        label="Interview Date"
                        prepend-icon="event_available"
                        readonly
                        hide-details
                        outlined
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="interviewDate"
                      @change="filterLeads()"
                      @input="menu5 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu7"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="interviewedDate"
                        label="Interviewed Date"
                        prepend-icon="event_available"
                        readonly
                        hide-details
                        outlined
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="interviewedDate"
                      @change="filterLeads()"
                      @input="menu7 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-menu
                    v-model="menu8"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="acceptedDate"
                        label="Accepted Date"
                        prepend-icon="event_available"
                        readonly
                        hide-details
                        outlined
                        @change="filterLeads()"
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="acceptedDate"
                      @change="filterLeads()"
                      @input="menu8 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col><v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-autocomplete
                    :items="['Manual', 'FB Lead', 'Telephone', 'Landing Page', 'Instagram Lead', 'Tiktok Lead']"
                    v-model="selectedSource"
                    :label="i18n.source"
                    autocomplete="disabled"
                    outlined
                    hide-details
                    dense
                    clearable
                    @change="filterLeads()"
                    item-value="id"
                    :class="`${arabic?'arFont':'enFont'}`"
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        <v-chip x-small>{{item}}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :class="`${arabic?'arFont':'enFont'}`"
                      >
                        {{item}}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`" v-if="user && user.role == 'master'">
                  <v-switch label="only AD" v-model="isNew" hide-details @change="filterLeads()"></v-switch>
                </v-col>

                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-1`">
                  <v-btn color="success" @click="exportEmails()">export emails</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} text-center`" style="font-size:24px;" TOTALSTATS>
          <v-progress-circular indeterminate v-if="loading" size="20" color="primary"></v-progress-circular>
          {{totals.total}} {{i18n.leads}}
        </v-col>
        <v-col cols="12" class="text-center" RELOAD>
          <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" @click="loadResource()">{{i18n.reload}}</v-btn>
        </v-col>
        <v-col cols="12" STATS>
          <Stats
            :loading="loading"
            :counter="counter"
            :totals="totals"
            :manage="manage"
            :user="user"
            :programs="programs"
            :statuses="statuses"
            @reassign="reassignLeadsOfInActive"
            @transfer="transferLeads"
            @transferAll="transferAllLeads"
            @updateUser="exupdateUser"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import listPanel from '@/components/listPanel'
import leadsStats from '@/components/leadsStats'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};
import Stats from '@/components/stats'
import json2csv from 'json2csv'

export default {
  components: { Search, Paging, multiDialog, listPanel, leadsStats, Stats },
  data() {
    return {
      loading:false,
      dialog:false,
      manage:true,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys: [{
              name: 'name',
              label: 'name',
              type: 'text',
              fetched: 'name',
              required: true
          },
          {
              name: 'program_id',
              label: 'program',
              type: 'select',
              items: 'programs',
              fetched: 'program_name',
              data: [],
              source: 'db',
              required: true,
              readonly: true
          },
          {
              name: 'country_id',
              label: 'country',
              type: 'select',
              items: 'countries',
              fetched: 'country_name',
              data: [],
              source: 'db',
              required: true,
              readonly: true
          },
          {
              name: 'email',
              label: 'email',
              type: 'text',
              fetched:'email',
              required: true,
              readonly: true
          },
          {
              name: 'phone',
              label: 'phone',
              type: 'text',
              fetched: 'phone',
              required: true,
              readonly: true
          },
          {
              name: 'source',
              label: 'source',
              type: 'text',
              fetched: 'source',
              required: true,
              readonly: true
          },
          {
              name: 'user_id',
              label: 'agent',
              type: 'select',
              items: 'usersall',
              fetched: 'user_name',
              data: [],
              source: 'db',
              required: true
          },
          {
              name: 'status_id',
              label: 'status',
              type: 'select',
              items: 'statuses',
              fetched: 'status_name',
              data: [],
              source: 'db',
              required: true
          },
          {
              name: 'appointment',
              label: 'appointment',
              type: 'date',
              fetched: 'appointment',
          },
          {
              name: 'note',
              label: 'note',
              type: 'textarea',
              fetched: 'note',
          },
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      programs:[],
      countries:[],
      statuses:[],
      usersall:[],
      selectedUser:null,
      selectedCountry:null,
      selectedProgram:null,
      selectedStatus:null,
      menu1:false,
      menu2:false,
      menu3:false,
      menu4:false,
      menu5:false,
      menu6:false,
      menu7:false,
      menu8:false,
      fromDate:null,
      toDate:null,
      fromUpdateDate:null,
      toUpdateDate:null,
      interviewDate:null,
      interviewedDate:null,
      acceptedDate:null,
      counter:null,
      totals:{},
      selectedSource:null,
      isNew:false,
    }
  },
  
  methods: {
    exportSimpleData(data, name){
      console.log(data)
      let a = json2csv.parse(data)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'failed_export'
      link.setAttribute("download", `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    async exportEmails() {
      this.loading = true
      let d = await this.$store.dispatch('getResource', {resource:'/leads-export' + '?' + this.buildFilter()})
      console.log(d)
      this.exportSimpleData(d.map(x=>{return {email:x.email}}), 'leads')
      this.loading = false
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    async exupdateUser({id, assign_ratio, assign, programs}){
        if(programs && programs.length) {
          programs = programs.map(x=>{
            if(x.id) {
              return x.id
            } else {
              return x
            }
          })
          programs = programs.filter(this.onlyUnique)
        }
      let update = {
        id,
        assign_ratio,
        assign,
        programs
      }
      let u = await this.$store.dispatch('putResource', {resource:'/users' + `/${id}`, value:update})
      if(!u.error) {
        this.$emit('snackbarNotification', `${u.name} updated`, 'success')
      }
      console.log(u)
    },
    async reassignLeadsOfInActive(data){
      this.loading = true
      console.log(data)
      let r = await axios.post(`${this.api}/reassign-leads`, {...data}, {headers}).then(x=>x.data)
      console.log(r)
      if(r.overall){
        this.$emit('snackbarNotification', `${r.leads_count} will be reassigned`, 'success')
        await this.loadSettingsItems()
        this.loading = false
      } else {
        this.$emit('snackbarNotification', `Failed`, 'error')
        this.loading = false
      }
    },
    async reassignLeads(data) {
      this.loading = true
      console.log(data)
      return
      let r = await axios.post(`${this.api}/re-proccess-leads`, { ...data }, { headers }).then(x => x.data)
      console.log(r)
      if (r.overall) {
        this.$emit('snackbarNotification', `${r.leads_count} will be reassigned`, 'success')
        await this.loadSettingsItems()
        this.loading = false
      } else {
        this.$emit('snackbarNotification', `Failed`, 'error')
        this.loading = false
      }
    },
    async transferAllLeads(data){
      this.loading = true
      console.log(data)
      let r = await axios.post(`${this.api}/transfer-all-leads`, {...data}, {headers}).then(x=>x.data)
      console.log(r)
      if(r.overall){
        this.$emit('snackbarNotification', `${r.leads_count} will be transfered`, 'success')
        await this.loadSettingsItems()
        this.loading = false
      } else {
        this.$emit('snackbarNotification', `Failed`, 'error')
        this.loading = false
      }
    },
    async transferLeads(data){
      this.loading = true
      console.log(data)
      let r = await axios.post(`${this.api}/transfer-leads`, {...data}, {headers}).then(x=>x.data)
      console.log(r)
      if(r.overall){
        this.$emit('snackbarNotification', `${r.leads_count} will be transfered`, 'success')
        await this.loadSettingsItems()
        this.loading = false
      } else {
        this.$emit('snackbarNotification', `Failed`, 'error')
        this.loading = false
      }
    },
    editLead(r){
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = await this.$store.dispatch('loadAllResource', {resource:`/${f.items}`})
            if(!t.error) {
              let maps = t.map(x=>{
                let t = x.name?x.name:x.company?x.company:x.country?x.country:x.program?x.program:null
                console.log(t)
                return{...x, text:t, [`${f.items}_id`]:x.id}
              })
              f.data = maps
            }
          }
          res(true)
        })()
      })
    },
    getItems(items) {
      return this.resourceKeys.filter(x=>x.items == items)[0].data
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadSettingsItems(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let ks = ['countries', 'programs', 'statuses', 'usersall'];
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = await this.$store.dispatch('getResource', {resource:`/${f}`})
            console.log('items', f, t)
            if(!t.error)
            t.forEach(x=> this.$store.state.i18n.en[x.slug] = x.en)
            t.forEach(x=> this.$store.state.i18n.ar[x.slug] = x.ar)
            t.forEach(x=> this.$store.state.i18n.fr[x.slug] = x.fr)
            this[f] = t
          }
          let rks = this.resourceKeys.filter(x=>x.type == 'select' && x.source == 'db')
          for (let i = 0; i < rks.length; i++) {
            const rk = rks[i];
            rk.data = this[rk.items].map(x=>{
              let text = x.slug ? this.i18n[x.slug] : x.name
              return{...x, [rk.name + '_id']: x.id, text}
            })
            console.log(rk.data)
          }
          this.loading = false
          res(true)
        })()
      })
    },
    buildFilter(){
      let filter = ``
      if(this.selectedCountry) {
        filter += `&country_id=${this.selectedCountry}`
      }
      if(this.selectedProgram) {
        filter += `&program_id=${this.selectedProgram}`
      }
      if(this.selectedStatus) {
        filter += `&status_id=${this.selectedStatus}`
      }
      if(!this.fromDate) this.fromDate = new Date( new Date().getTime() - 24*60*60*1000 ).toISOString().split('T')[0]
      if(!this.toDate) this.toDate = new Date().toISOString().split('T')[0]
      if(this.fromDate && this.toDate) {
        filter += `&from_date=${this.fromDate}&to_date=${this.toDate}`
      }
      if(this.fromUpdateDate && this.toUpdateDate) {
        filter += `&from_update_date=${this.fromUpdateDate}&to_update_date=${this.toUpdateDate}`
      }
      if(this.interviewDate) {
        filter += `&interview_date=${this.interviewDate}`
      }
      if(this.interviewedDate) {
        filter += `&confirmed_date=${this.interviewedDate}`
      }
      if(this.acceptedDate) {
        filter += `&accepted_date=${this.acceptedDate}`
      }
      if(this.selectedUser) {
        filter += `&user_id=${this.selectedUser}`
      }
      if(this.selectedSource) {
        filter += `&source=${this.selectedSource}`
      }
      if(this.isNew) {
        filter += `&only_advert=${this.isNew?'filter':''}`
      }
      if(this.isAutoconfirmed) {
        filter += `&only_autocon=${this.isAutoconfirmed?'filter':''}`
      }
      
      return filter
    },
    async filterLeads(){
      await this.loadResource()
    },
    firstLoad(){
      if(this.user && !this.user.hq) {
        console.log(this.user)
        this.selectedCountry = this.user.countries[0].id
      }
    },
    async Counter(counter){
      return new Promise(async (res, rej)=>{
        // let counter = await this.$store.dispatch('getResource', {resource:this.$route.path + '-counter' + '?' + this.buildFilter()})
        console.log('counter', counter, this.resource.counters)
        let c = this.countries.map(x=>x.id)
        let c_grouped = []
        let c_employees = []
        let c_n = counter.map(x=>{
          return {
            ...x,
            country_name:this.countries.filter(y=>y.id == x.country)[0],
            program_name:this.programs.filter(y=>y.id == x.program)[0],
            status_name:this.statuses.filter(y=>y.id == x.status)[0],
            users:this.usersall.filter(z=>z.countries.map(y=>y.id).includes(x.country))
          }
        })
        c.forEach(id => {
          c_grouped.push([...c_n.filter(x=>x.country == id)])
        });
        
        this.counter = c_grouped.filter(x=>x.length).filter(x=>x.length).map(x=>x.sort((a, b)=> a.program - b.program))
        this.totals = {
          total: counter.reduce((total, a)=> total + a.total_count , 0)
        }
        
        console.log('this.usersall', this.usersall)
        console.log('this.counter', this.counter)
        res()
      })
    },
    
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(this.search)
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/leads' + '?' + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:'/leads' + '/search', value:this.search})
        }
        await this.Counter(this.resource.counters)
        await this.loadSettingsItems()
        this.loading = false
        res()
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/leads', page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:'/leads' + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:'/leads' + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('putResource', {resource:'/leads' + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:'/leads' + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:'/leads' + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    },
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.firstLoad()
    this.loadSettingsItems()
    await this.loadItems()
    this.setResourceName()
    await this.loadResource()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>